export default "__VITE_ASSET__BVLvW9Bl__"